export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Nachrichteneingang",
    subtitle: "WhatsApp, Web-Concierge und OTA an einem Ort",
  },

  channels: {
    all: "Alle",
    whatsapp: "WhatsApp",
    web: "Web",
    ota: "OTA",
  },

  empty: {
    title: "Keine neuen Nachrichten",
    description: "Neue Bot-Nachrichten erscheinen hier, sobald sie eintreffen",
  },

  buttons: {
    markAll: "Alle als gelesen markieren",
    goToChat: "KI-Agent konfigurieren",
    archive: "Konversation archivieren",
  },

  actions: {
    replyWhatsApp: "Auf WhatsApp antworten",
  },

  time: {
    now: "Jetzt",
    minuteSuffix: "Min.",
    hourSuffix: "Std.",
    daySuffix: "T",
    today: "Heute",
    yesterday: "Gestern",
  },

  questions: {
    searchPlaceholder: "Fragen suchen...",
    answered: "Beantwortet",
    noAnswer: "Ausstehend",
    withImage: "Mit Bild",
    empty: "Keine Fragen gefunden",
    confirmDelete: "Möchten Sie diese Frage wirklich löschen?",
  },

  answer: {
    assistantResponse: "Antwort des Assistenten",
    attachedImageOptional: "Angehängtes Bild (optional)",
    uploadImage: "Bild hochladen",
    clickToSelect: "Klicken Sie, um ein Bild auszuwählen",
    changeImage: "Bild ändern",
    imagePreviewAlt: "Bildvorschau",
    defaultImageName: "image.jpg",
  },

  phone: {
    online: "online",
    today: "Heute",
    exampleQuestion: "Beispielfrage",
    writeAnswerPlaceholder: "Schreiben Sie eine Antwort auf diese Frage...",
    writeMessagePlaceholder: "Nachricht schreiben...",
    answerImageAlt: "Antwortbild",
    confirmDeleteImage: "Bild löschen?",
    imageDeletedSuccess: "Bild erfolgreich gelöscht.",
    virtualAssistant: "Virtueller Assistent",
  },

  search: {
    placeholder: "Nach Name, Telefon oder Buchungscode suchen...",
    noResultsTitle: "Keine Konversationen gefunden",
    noResultsDescription:
      "Versuchen Sie einen anderen Namen, eine andere Telefonnummer oder einen anderen Buchungscode.",
  },

  archive: {
    title: "Konversation archivieren",
    message:
      "Wenn Sie diese Konversation archivieren, verschwindet sie aus dieser Liste. Sie können weiterhin über die verknüpfte Buchung darauf zugreifen.",
    cancel: "Abbrechen",
    confirm: "Archivieren",
  },
};

export default bot;
